import {
    HttpEvent,
    HttpHandlerFn,
    HttpHeaders,
    HttpInterceptorFn,
    HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, Observable, catchError, tap, throwError } from 'rxjs';
import { AuthService } from '../helpers/auth.service';
import { environment } from '../../../environments/environment';
import { AlertService } from '../helpers/alert.service';
import { SessionService } from '../helpers/session.service';
import { ErrorsService } from '../helpers/errors.service';
import { DataInterceptorService } from '../helpers/data-interceptor.service';
import { DataInterceptorModel } from '../../domain/models/internal/data-interceptor.model';


/**
 * Method interceptor
 * @param request 
 * @param next 
 * @returns request result
 */
export const authInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

    const auth = inject(AuthService);
    const alert = inject(AlertService);
    const errors = inject(ErrorsService);
    const session = inject(SessionService);
    const dataService = inject(DataInterceptorService);
    const token = auth.getToken();
    const expired =auth.getTokenExpire();
    const CODES = [403];
    const baseUrl = environment.baseUrl;
    const urlNoToken = ['Usuarios/Authenticate','Usuarios/BuildSendOTPChangePassword', 'Usuarios/ValidateOTPChangePassword','Usuarios/UsuarioChangePassword', 'Usuarios/VerifyCaptcha'];
    const header = new HttpHeaders({
        'Content-Type': 'application/json;charset=utf-8'
    });
    const menGeneric='Nuestro servicio está experimentando una falla técnica. Inténtalo de nuevo más tarde';
    const menToken='El tiempo de sesión ha expirado.';
    const menAuth = 'No está autorizado para realizar esta petición';

    if (request.headers.get("No-Auth") == "True") {
        return next(request.clone({ headers: header })).pipe(
            tap((response:any)=>{
                if(response.body!=undefined && environment.dataInterceptor){
                    let data:DataInterceptorModel ={
                      Request: request,
                      Response: response
                    }
                    dataService.showData(data);
                }
            }),
            catchError((error: any) => {
                if(environment.dataInterceptor){
                    let data:DataInterceptorModel ={
                      Request: request,
                      Error: error
                    }
                    dataService.showError(data);
                }
                
                if (CODES.includes(error.status)) {
                    let message =  errors.searchStatus(error.status);
                    session.clearToken();
                    alert.alertErrorRedireccTo(message!,'Lo sentimos',1,'Entendido')
                }
                if (error.status==401) {
                    session.clearToken();
                    alert.alertErrorRedireccTo(menAuth,'Lo sentimos',1,'Entendido')
                }
                if (error.status==404) {
                    session.clearToken();
                    alert.alertErrorRedireccTo(menGeneric,'Lo sentimos',1,'Entendido')
                }
                return throwError(() => error);
            }));
    }

    if (urlNoToken.includes(request.url.slice(baseUrl.length + 1)) || urlNoToken.includes((request.url.slice(baseUrl.length + 1)).split('?')[0])) {
        return next(request.clone({ headers: header })).pipe(
            tap((response:any)=>{
                if(response.body!=undefined && environment.dataInterceptor){
                    let data:DataInterceptorModel ={
                      Request: request,
                      Response: response
                    }
                    dataService.showData(data);
                }
            }),
            catchError((error: any) => {

                if(environment.dataInterceptor){
                    let data:DataInterceptorModel ={
                      Request: request,
                      Error: error
                    }
                    dataService.showError(data);
                }
                
                if (CODES.includes(error.status)) {
                    let message = errors.searchStatus(error.status);
                    session.clearToken();
                    alert.alertErrorRedireccTo(message!,'Lo sentimos',1,'Entendido')
                }
                if (error.status==401) {
                    session.clearToken();
                    alert.alertErrorRedireccTo(menAuth,'Lo sentimos',1,'Entendido')
                }
                if (error.status==404) {
                    session.clearToken();
                    alert.alertErrorRedireccTo(menGeneric,'Lo sentimos',1,'Entendido')
                }
                return throwError(() => error);
            }));
    }

    if (token != null && expired != null) {
        const date: number = new Date().getTime();
        if (date <= Number(expired)) { 
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${ token }`
                }
            });
            return next(request).pipe(
                tap((response:any)=>{
                    if(response.body!=undefined && environment.dataInterceptor){
                        let data:DataInterceptorModel ={
                          Request: request,
                          Response: response
                        }
                        dataService.showData(data);
                    }
                }),
                catchError((error: any) => {

                    if(environment.dataInterceptor){
                        let data:DataInterceptorModel ={
                          Request: request,
                          Error: error
                        }
                        dataService.showError(data);
                    }
                    
                    if (CODES.includes(error.status)) {
                        let message =  errors.searchStatus(error.status);
                        session.clearToken();
                        alert.alertErrorRedireccTo(message!,'Lo sentimos',1,'Entendido');
                    }
                    if (error.status==401) {
                        session.clearToken();
                        alert.alertErrorRedireccTo(menAuth,'Lo sentimos',1,'Entendido')
                    }
                    if (error.status==404) {
                        session.clearToken();
                        alert.alertErrorRedireccTo(menGeneric,'Lo sentimos',1,'Entendido');
                    }
                    return throwError(() => error);
                }));
        }else{
            session.clearToken();
            alert.alertErrorRedireccTo(menToken,'Lo sentimos',1,'Entendido');
            return EMPTY;
        }
    } else {
        session.clearToken();
        alert.alertErrorRedireccTo(menToken,'Lo sentimos',1,'Entendido');
        return EMPTY;
    }
    
}
